import { API, postJSON } from "../../api.js";
import { $, esc, fmtMoney } from "../../ui/format.js";
import { helpIcon } from "../../ui/help.js";
import { toast } from "../../ui/modals.js";

// ---------------------------------------------------------------- FX Exposure

async function renderFX(main, snap) {
  main.innerHTML = `
    <div class="sx">
      <header class="sx-header"><div><h2 class="sx-title">Your currencies ${helpIcon("fx")}</h2>
        <p class="sx-sub">Month ${snap.month}. Revenue earned in other currencies moves with exchange rates; a hedge locks today's rate for six months.</p></div></header>
      <div class="plain-english-card" id="fx-plain-english">Loading…</div>
      <div id="fx-summary">Loading…</div>
      <section class="sx-card"><div class="sx-card-head"><div><h3 class="sx-card-title">Currency by currency</h3></div></div><div id="fx-rows">Loading…</div></section>
      <section class="sx-card"><div class="sx-card-head"><div><h3 class="sx-card-title">Your hedges</h3></div></div><div id="fx-hedges">Loading…</div></section>
    </div>`;

  const fx = await fetch(`${API}/fx/status`).then((x) => x.json());
  const unhedgedBig = [...fx.currencies].filter((c) => !c.hedged).sort((a, b) => b.revenue_share_pct - a.revenue_share_pct)[0];
  $("fx-plain-english").innerHTML = !fx.currencies.length
    ? `No international revenue yet — expand into another country to take on real currency exposure (and the option to hedge it).`
    : `${fx.total_international_exposure_pct}% of your revenue is currency-exposed across ${fx.currencies.length} currenc${fx.currencies.length > 1 ? "ies" : "y"}.
       ${unhedgedBig ? `Your biggest unhedged risk is <strong style="color:var(--text-hi);">${esc(unhedgedBig.currency)}</strong> (${unhedgedBig.revenue_share_pct}% of revenue, ~${(unhedgedBig.volatility*100).toFixed(1)}% monthly swings).` : "Everything meaningful is currently hedged."}`;

  $("fx-summary").innerHTML = `
    <div class="sx-kpis">
      <div class="sx-kpi"><div class="sx-kpi-label">Revenue in other currencies</div><div class="sx-kpi-value">${fx.total_international_exposure_pct}%</div></div>
      <div class="sx-kpi"><div class="sx-kpi-label">Currencies</div><div class="sx-kpi-value">${fx.currencies.length}</div></div>
      <div class="sx-kpi"><div class="sx-kpi-label">Hedged</div><div class="sx-kpi-value">${fx.currencies.filter((c) => c.hedged).length}</div></div>
    </div>`;

  if (!fx.currencies.length) {
    $("fx-rows").innerHTML = `<div class="sx-empty"><div class="sx-empty-title">No other currencies yet</div><p>All your revenue is at home. Enter a country to earn in its currency (and take on its swings).</p>
      <button type="button" class="primary" data-go-gov>Explore a country →</button></div>`;
    const go = $("fx-rows").querySelector("[data-go-gov]");
    if (go) go.addEventListener("click", () => window.ges && window.ges.showTab("government"));
  } else {
    $("fx-rows").innerHTML = fx.currencies.map((c) => `
      <div class="fx-row">
        <div>
          <div class="fx-currency-name">${esc(c.currency)}</div>
          <div class="fx-vol-tag">${c.revenue_share_pct}% of revenue · monthly volatility ~${(c.volatility*100).toFixed(1)}%</div>
        </div>
        <div style="display:flex; align-items:center; gap:12px;">
          <span class="mono">rate ${c.current_rate}</span>
          <span class="${c.hedged ? "insured-tag" : "uninsured-tag"}">${c.hedged ? `Hedged to M${c.hedge_expires_month}` : "Unhedged"}</span>
          ${c.hedged ? "" : `<button data-hedge="${esc(c.currency)}">Hedge for 6 months</button>`}
        </div>
      </div>
    `).join("");
    $("fx-rows").querySelectorAll("[data-hedge]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const res = await postJSON("/fx/hedge", { currency: btn.dataset.hedge, months: 6 });
        await window.refreshAll();
        toast(res.message);
      });
    });
  }

  $("fx-hedges").innerHTML = fx.active_hedges.length ? fx.active_hedges.map((h) => `
    <div class="risk-row">
      <div class="risk-row-left">
        <div class="risk-row-label">${esc(h.currency)}</div>
        <div class="risk-row-sub">Locked at ${h.locked_rate} · premium ${fmtMoney(h.premium_paid)} · expires month ${h.month_expires}</div>
      </div>
    </div>
  `).join("") : `<p class="sx-card-sub">No hedges: every currency moves your revenue as rates change.</p>`;
}

export { renderFX };
